module.exports = __webpack_public_path__ + "static/media/doc.9030970a.svg";